import React from 'react';
import Logo from './Logo';
import { Instagram, Facebook, Mail, Phone } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-black text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Logo and About */}
          <div className="col-span-1 md:col-span-2">
            <Logo />
            <p className="mt-4 text-gray-400 text-sm">
              Elite online personal training from <br />
              Australia's most dedicated fitness expert. <br />
              Transform your body with custom programs <br />
              tailored to your goals.
            </p>
          </div>
          
          {/* Empty spacer column */}
          <div className="hidden md:block"></div>
          
          {/* Contact Info & Social Media - Moved Further Right */}
          <div className="col-span-1">
            <h3 className="text-lg font-bold mb-4">CONTACT</h3>
            <ul className="space-y-2">
              <li>
                <a 
                  href="mailto:info@eliteshape.com.au" 
                  className="text-gray-400 hover:text-red-500 transition-colors text-sm flex items-center gap-2"
                >
                  <Mail size={16} />
                  info@eliteshape.com.au
                </a>
              </li>
              <li>
                <a 
                  href="tel:+61234567890" 
                  className="text-gray-400 hover:text-red-500 transition-colors text-sm flex items-center gap-2"
                >
                </a>
              </li>
            </ul>
            
            {/* Social Media */}
            {/* Social Media */}
            <div className="mt-6">
              <h4 className="text-sm font-semibold mb-3">FOLLOW US</h4>
              <div className="flex space-x-4">
                <a 
                  href="https://www.instagram.com/eliteshapepersonaltraining/" 
                  target="_blank"
                  rel="nofollow sponsored noopener noreferrer"
                  className="text-gray-400 hover:text-red-500 transition-colors"
                >
                  <Instagram size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} KovaKit Websites. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;